import '@babel/polyfill'
import Vue from 'vue'
import './plugins/axios'
import vuetify from './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'

import LayoutUnauthenticated from '@/views/layouts/Unauthenticated.vue'
import LayoutAuthenticated from '@/views/layouts/Authenticated.vue'

import Alert from '@/components/Alert.vue'
import Footer from '@/components/Footer.vue'
import AppGlobalError from '@/components/app/GlobalError.vue'
import AppActivityIndicator from '@/components/app/ActivityIndicator.vue'
import AppDeleteConfirmationDialog from '@/components/app/DeleteConfirmationDialog.vue'
import EditPasswordDialog from '@/components/EditPasswordDialog.vue'
import AppNotificationSnackbar from '@/components/app/NotificationSnackbar.vue'
import EditAccountDetailsDialog from '@/views/accounts/EditAccountDetailsDialog.vue'
import EditAccountExtraMenu from '@/views/accounts/EditAccountExtraMenu.vue'
import CompleteAccountDialog from '@/views/accounts/CompleteAccountDialog.vue'
import VendorAccountNewDialog from '@/views/vendor/VendorAccountNewDialog.vue'
import VendorAccountEditDialog from '@/views/vendor/VendorAccountEditDialog.vue'
import ProductPurchaseDialog from '@/components/ProductPurchaseDialog'
import DatePicker from '@/components/app/DatePicker'
import TimePicker from '@/components/app/TimePicker'
import CustomClause from '@/components/CustomClause'

import FormatDate from '@/filters/FormatDate'
import FormatDatePicker from '@/filters/FormatDatePicker'

Vue.config.productionTip = false

Vue.component('app-layout-unauthenticated', LayoutUnauthenticated)
Vue.component('app-layout-authenticated', LayoutAuthenticated)
Vue.component('app-alert', Alert)
Vue.component('app-footer', Footer)
Vue.component('app-edit-account-details-dialog', EditAccountDetailsDialog)
Vue.component('app-edit-account-extra-menu', EditAccountExtraMenu)
Vue.component('app-edit-password-dialog', EditPasswordDialog)
Vue.component('app-complete-account-dialog', CompleteAccountDialog)
Vue.component('vendor-account-new-dialog', VendorAccountNewDialog)
Vue.component('vendor-account-edit-dialog', VendorAccountEditDialog)
Vue.component('app-global-error', AppGlobalError)
Vue.component('app-activity-indicator', AppActivityIndicator)
Vue.component('app-delete-confirmation-dialog', AppDeleteConfirmationDialog)
Vue.component('app-notification-snackbar', AppNotificationSnackbar)
Vue.component('product-purchase-dialog', ProductPurchaseDialog)
Vue.component('app-datepicker', DatePicker)
Vue.component('app-timepicker', TimePicker)
Vue.component('app-custom-clause', CustomClause)

Vue.filter('formatDate', FormatDate)
Vue.filter('formatDatePicker', FormatDatePicker)

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App),
  created () {
    console.log('user id token : ' + window.localStorage.getItem('jwt'))
    // auto signin user that already has credentials stored in cookies
    var jwt = window.localStorage.getItem('jwt')
    var role = window.localStorage.getItem('role')
    if (jwt !== null && jwt !== 'undefined' && jwt !== '') {
      this.$store.dispatch('autoSignIn', { token: jwt, role: role })
      this.$store.dispatch('loadUserData')
    }
  }
}).$mount('#app')
